export default __webpack_public_path__ + "static/media/2381.7a37bc05.png";